import axios from './_nestAxios'

export const getAsSelect = () =>
  axios.get('/plantillas-cobranza', { params: { tipoConsulta: 'select' } })

export const nuevo = data => axios.post('/plantillas-cobranza', data)

export const eliminarxId = _id => axios.delete(`/plantillas-cobranza/${_id}`)
